define("shared/models/ig-comment", ["exports", "@ember/object", "@ember/template", "@ember/utils", "moment"], function (_exports, _object, _template, _utils, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/template",0,"@ember/utils",0,"moment"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class IgComment extends _object.default {
    constructor(attrs) {
      super();
      _defineProperty(this, "createdTime", void 0);
      _defineProperty(this, "id", '');
      _defineProperty(this, "hidden", false);
      _defineProperty(this, "likeCount", 0);
      _defineProperty(this, "mediaId", void 0);
      _defineProperty(this, "nextRepliesUrl", void 0);
      _defineProperty(this, "parentId", void 0);
      _defineProperty(this, "replies", []);
      _defineProperty(this, "socialProfile", void 0);
      _defineProperty(this, "text", '');
      _defineProperty(this, "username", '');
      this.createdTime = attrs.createdTime;
      this.id = attrs.id;
      this.likeCount = attrs.likeCount;
      this.mediaId = attrs.mediaId;
      this.nextRepliesUrl = attrs.nextRepliesUrl;
      this.replies = attrs.replies;
      this.socialProfile = attrs.socialProfile;
      this.text = attrs.text;
      this.username = attrs.username;
    }
    get createdMoment() {
      return (0, _moment.default)(this.createdTime * 1000);
    }
    get formattedTime() {
      const time = this.createdTime;

      // Posted today
      if ((0, _moment.default)(time * 1000).isSame((0, _moment.default)(), 'day')) {
        return (0, _moment.default)(time * 1000).format('h:mm A');
      }
      return (0, _moment.default)(time * 1000).format('DD MMM');
    }
    get hasMoreReplies() {
      return !(0, _utils.isEmpty)(this.nextRepliesUrl);
    }
    get isReply() {
      return !(0, _utils.isEmpty)(this.parentId);
    }
    get textFormatted() {
      const formattedText = this.textWithLinebreaks.toString() || '';
      return (0, _template.htmlSafe)(formattedText);
    }
    get textFormattedTruncateShort() {
      let truncatedText = this.textWithLinebreaks.toString() || '';
      const lines = truncatedText.split('<br>');
      const numLines = lines.length;
      if (numLines > 3) {
        truncatedText = lines.slice(0, 3).join('<br>') + '...';
      } else if (truncatedText.length > 20) {
        truncatedText = truncatedText.substring(0, 80) + '...';
      }
      return (0, _template.htmlSafe)(truncatedText);
    }
    get textFormattedTruncateMedium() {
      let truncatedText = this.textWithLinebreaks.toString() || '';
      const lines = truncatedText.split('<br>');
      const numLines = lines.length;
      if (numLines > 5) {
        truncatedText = lines.slice(0, 5).join('<br>') + '...';
      } else if (truncatedText.length > 200) {
        truncatedText = truncatedText.substring(0, 200) + '...';
      }
      return (0, _template.htmlSafe)(truncatedText);
    }
    get textTruncated() {
      return this.text.length > 100 ? this.text.substring(0, 100) + '...' : this.text;
    }
    get textWithLinebreaks() {
      let formattedText = this.text || '';
      if (!formattedText) {
        return (0, _template.htmlSafe)('');
      }
      formattedText = formattedText.replace(/(\r\n|\n|\r)/gm, '<br>');
      return (0, _template.htmlSafe)(formattedText);
    }
  }
  _exports.default = IgComment;
});